<div class="zmenu-panel">
  <div class="zmenu-panel__heading zmenu-panel__heading--zblue">
    <i class="material-icons zmenu-panel__heading-icon zmenu-panel__heading-icon--zblue" (click)="goBack()"> cancel</i>
    <div class="zmenu-panel__heading--spacer">&nbsp;</div>
    <h2>Help</h2>
    <div class="zmenu-panel__heading--spacer zmenu-panel__heading--icon-width">&nbsp;</div>
  </div>

  <div class="zhelp">
    <div *ngFor="let help of helpList" class="zhelp-item">
      <div class="zhelp-item__icon zhelp-item__icon--zblue">
        <i class="material-icons">{{ help.icon }}</i>
      </div>
      <div class="zhelp-item__title">{{ help.title }}</div>
    </div>
  </div>
</div>
